module.exports = __webpack_public_path__ + "static/media/36.1143da0e.JPG";